import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "parts/Cards/InfoCards/DefaultInfoCard";
import CenteredBlogCard from "parts/Cards/BlogCards/CenteredBlogCard";
// Image
import bgImage from "assets/images/contact.jpg";
function Information() {
  return (
    <MKBox
      component="section"
      py={12}
      sx={{
        pt: "100px",  // Adds space at the top to avoid overlap with fixed navbar
      }}
    >
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={6}>
            <Grid container justifyContent="flex-start">
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="public"
                    title="AI-Powered Automation"
                    description="Automate repetitive tasks and workflows using AI to improve efficiency, reduce human error, and free up resources for more strategic activities. AI-powered automation allows businesses to focus on innovation and growth by handling routine operations seamlessly."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={5}>
                  <DefaultInfoCard
                    icon="public"
                    title="Predictive Analytics"
                    description="Leverage AI to analyze historical data and generate actionable predictions for future outcomes. Our AI-powered predictive analytics solutions help businesses make proactive decisions, optimize operations, and drive growth with confidence."
                  />
                </MKBox>
              </Grid>
              <Grid item xs={12} md={6}>
                <MKBox mb={{ xs: 5, md: 0 }}>
                  <DefaultInfoCard
                    icon="public"
                    title="AI-Driven Data Analysis"
                    description="Harness the power of AI to analyze large volumes of data quickly and accurately. Our solutions uncover critical insights and trends, enabling you to craft data-driven strategies and foster innovation in your organization."
                  />
                </MKBox>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} lg={4} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <CenteredBlogCard
              image={bgImage}
              title="Get insights"
              description="In today's rapidly evolving digital landscape, staying informed is key to making smart decisions. At HP Tech Solutions, we provide valuable insights into the latest trends, challenges, and opportunities in software development and cybersecurity."
              action={{
                type: "internal",
                route: "/pages/landing-pages/contact-us",
                color: "info",
                label: "Contact",
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Information;
